import * as RadixAvatar from '@radix-ui/react-avatar'
import React from 'react'
import styled from 'styled-components'

import { Tooltip } from '@blade/ui-kit'

import type { Provider } from '../model'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  provider: Provider.Provider
  size?: number
  withNetwork?: boolean
  withTooltip?: boolean
} & ClassNameProps

export const ProviderIcon: React.FC<Props> = ({
  provider,
  size = 32,
  className,
  withTooltip = false,
}) => {
  const fontSize = Math.round(size * 0.3)

  const renderContent = () => {
    return (
      <Root
        className={className}
        style={{
          width: size,
          height: size,
          fontSize: fontSize,
        }}
      >
        <Image src={provider.logoUrl} alt={provider.title} />
        <Fallback delayMs={0}></Fallback>
      </Root>
    )
  }

  if (withTooltip) {
    return <Tooltip content={provider.title}>{renderContent()}</Tooltip>
  }

  return renderContent()
}

const Root = styled(RadixAvatar.Root)`
  border-radius: 50%;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  background-color: transparent;
`

const Image = styled(RadixAvatar.Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
  pointer-events: none;
`

const Fallback = styled(RadixAvatar.Fallback)`
  font-weight: 800;
  text-align: center;
  color: var(--text-12);
`
